import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { withLocalize } from "react-localize-redux";
import { Checkbox, Spin, Tooltip } from "antd";
import {
  SelectDiv,
  StyledSelectInput,
  StyledOption,
  SelectArrow,
  CloseArrow,
  ArrowImg,
  StyledOptionContent,
  SelectLabelInput,
  MultipleStyledSelectInput,
  MultipleSelectDiv,
  SelectOptions,
  SelectOption,
  SelectOptionUpgradeSelection
} from "./InputStyles";
import ArrowDown from "../../assets/icons/arrow_down.svg";
import Close from "../../assets/icons/close.svg";
import { MaterialInput } from "./MaterialStyles";

const SelectRestrictionInput = ({
  input,
  data,
  dataKey,
  dataLabel,
  placeholder,
  label,
  disabled,
  meta,
  translatable = true,
  activeLanguage,
  allowClear,
  blockMainDishes,
  restrictionsColors
}) => {
  const { invalid, submitFailed } = meta;
  const showError = invalid && submitFailed;
  const [open, toogleOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  // useEffect(() => {
  //   setOptions(data.map(m => ({ ...m, checked: false })))
  // }, [data]);

  useEffect(() => {
    if (data?.length > 0) {
      setOptions(data.map(m => ({ ...m, checked: input.value?.includes(m._id) })));
    }
  }, [data, input.value]);

  useEffect(() => {
    setValue(input.value || []);

    const value = input?.value || [];
    const options = data.map(m => ({ ...m, checked: value?.includes(m?._id) }));
    setOptions(options);
  }, [input.value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current?.contains(event.target)) {
        toogleOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const formatValue = () => {
    const value = input.value;
    if (!value) return undefined;
    if (Array.isArray(value)) {
      const selected = value?.length > 0
        ? options.filter(f => value.includes(f?._id))
        : [];
      return selected?.length > 0
        ? selected?.map(m => m?.acronym[activeLanguage.code])?.join(', ')
        : undefined;
    }
    return value.toString();
  };

  const isFilled = () => {
    return input?.value && Array.isArray(input?.value) && input?.value?.length > 0 ? true : false;
  }

  const changeSelect = value => {
    input.onChange(value || '');
  };

  const changeChecked = (event, elem) => {
    let value = input.value || [];

    if (event?.target.checked) {
      if (elem.upgradeSelection) {
        value = value.filter(id => {
          const option = data.find(item => item._id === id);
          return option && !option.upgradeSelection;
        });
      }
      value.push(elem._id);
    } else {
      value = value.filter(f => f != elem._id);
    }

    const options = data.map(m => ({
      ...m,
      checked: value.includes(m._id),
    }));

    setOptions(options);
    changeSelect(value);
  };

  const openOptions = () => {
    input.onFocus();
    if (disabled) return;
    toogleOpen(!open)
  }

  const BLOCKED_MAIN_DISHES_IDS = () => {
    if (blockMainDishes) {
      return [
        '67c03cceb272a8dfe4179380',
        '67c03d27b272a8dfe4179381'
      ];
    }

    return [];
  }

  return (
    <MultipleSelectDiv ref={dropdownRef}>
      {label && <SelectLabelInput>{label}</SelectLabelInput>}
      <MultipleStyledSelectInput filled={isFilled()} disabled={disabled} onClick={() => openOptions()} restrictionsColors={restrictionsColors}>
        <div className="select-input">
          {formatValue()}
        </div>
        {
          !disabled && (allowClear && input?.value && input?.value?.length > 0 && formatValue() != undefined
            ? <CloseArrow smallIcon={true} onClick={() => changeSelect([])}><ArrowImg src={Close} /></CloseArrow>
            : <SelectArrow smallIcon={true}><ArrowImg src={ArrowDown} /></SelectArrow>)
        }
      </MultipleStyledSelectInput>
      {open && <SelectOptions>
        <div style={{ padding: '4px 8px' }}>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '100%',
              padding: '4px 8px',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              outline: 'none',
              fontSize: '13px'
            }}
            autoFocus
          />
        </div>
        {options
          .filter((elem) => {
            if (!searchTerm) return true;
            const term = searchTerm.toLowerCase();
            const acronym = elem?.acronym?.[activeLanguage.code]?.toLowerCase() || '';
            const name = elem?.subtitle?.[activeLanguage.code]?.toLowerCase() || '';
            return acronym.includes(term) || name.includes(term);
          })
          .map((elem, index) => (
          <Tooltip key={dataKey ? elem[dataKey] : index} title={elem['subtitle'][activeLanguage.code]}>
            <SelectOptionUpgradeSelection key={dataKey ? elem[dataKey] : index} disabled={BLOCKED_MAIN_DISHES_IDS().includes(elem[dataKey]) || elem?.disabled} upgradeSelection={elem?.upgradeSelection}>
              <Checkbox checked={elem.checked} onChange={(e) => changeChecked(e, elem)} disabled={BLOCKED_MAIN_DISHES_IDS().includes(elem[dataKey])}>
                {dataLabel
                  ? (translatable ? elem[dataLabel][activeLanguage.code] : elem[dataLabel])
                  : elem}
              </Checkbox>
            </SelectOptionUpgradeSelection>
          </Tooltip>
        ))}
      </SelectOptions>}
    </MultipleSelectDiv>
  );
};

SelectRestrictionInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  dataKey: PropTypes.string,
  dataLabel: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  fetchData: PropTypes.func,
  loading: PropTypes.bool,
  onPressEnter: PropTypes.func,
  allowClear: PropTypes.bool,
  removeSelection: PropTypes.func,
  tag: PropTypes.string
};

SelectRestrictionInput.defaultProps = {
  data: [],
  allowClear: true,
  dataLabel: 'acronym',
  dataKey: '_id'
};

export default withLocalize(SelectRestrictionInput);
